import React from 'react';
import { createBrowserRouter } from "react-router-dom";
import CoachingAppBase from "../components/CoachingAppBase";

const FourOhFour = React.lazy(() => import('~/shared/layouts/FourOhFour'));
const Home = React.lazy(() => import('../components/pages/Home'));
const Contact = React.lazy(() => import('../components/pages/Contact'));

const router = createBrowserRouter([
  {
    path: "/",
    element: <CoachingAppBase />,
    errorElement: <CoachingAppBase />,
    children: [
      {
        index: true,
        element: <Home />
      },
      {
        path: "pages",
        children: [
          {
            path: "contact",
            element: <Contact />
          },
        ]
      }
    ],
  },
  {
    path: '*',
    element: <FourOhFour />
  }
]);

export default router;